var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('DraggableTestDashboard',{attrs:{"id_group":_vm.$route.params.id,"show_btns":_vm.show_btns()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }